import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed, ref } from "vue";
import * as networkState from "../../../../utilities/network-state";
import FadeAndSlide from "../../shared/FadeAndSlide.vue";
import labels from "../../shared/labels";
import { onConnectionChange } from "../../../../web-workers/auction-socket";



export default /*@__PURE__*/_defineComponent({
  __name: 'OfflineWarning',
  setup(__props) {

const socketOffline = ref(false);
const networkOffline = ref(false);
const socketListenerInit = ref(false);

const offline = computed(() => {
    return socketOffline.value === true || networkOffline.value === true;
});

// watch(
//     () => offline.value,
//     (newValue) => {
//         console.debug("detected", newValue ? "offline" : "online");
//     }
// );

function ensureInitSocket() {
    if (socketListenerInit.value === true) return;

    {
        socketListenerInit.value = true;
        onConnectionChange((v) => {
            // console.debug("has netvork socket: " + v);
            socketOffline.value = !v;
        });
        return;
    }

    requestAnimationFrame(() => {
        setTimeout(() => {
            ensureInitSocket();
        }, 100);
    });
}

ensureInitSocket();
networkState.onChange((v) => {
    networkOffline.value = v.type === "offline";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (offline.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style['offline-box'])
            }, _toDisplayString(_unref(labels).frontendProductpage.specs.connectionIssues), 3 /* TEXT, CLASS */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    })
  ]))
}
}

})